import { render, staticRenderFns } from "./ModalPrevisualizacionAdjunto.vue?vue&type=template&id=6987acaf&scoped=true"
import script from "./ModalPrevisualizacionAdjunto.vue?vue&type=script&lang=js"
export * from "./ModalPrevisualizacionAdjunto.vue?vue&type=script&lang=js"
import style0 from "./ModalPrevisualizacionAdjunto.vue?vue&type=style&index=0&id=6987acaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987acaf",
  null
  
)

export default component.exports